var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "booking-summary__sidebar" } },
    [
      _c(
        "div",
        {
          staticClass: "booking-summary__intro",
          on: {
            click: function ($event) {
              return _vm.$emit("toggle-summary")
            },
          },
        },
        [_vm._m(0), _vm._v(" "), _vm._m(1)]
      ),
      _vm._v(" "),
      _vm._l(_vm.summary, function (section) {
        return _c(
          "div",
          {
            staticClass: "booking-summary__subsection",
            on: {
              click: function ($event) {
                return _vm.stepBackTo(section.section)
              },
            },
          },
          [
            _c("div", { staticClass: "booking-summary__title" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t(`booking.sectionTitles.${section.section}`)) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "booking-summary__infos" },
              _vm._l(section.infos, function (info) {
                return _c("li", { staticClass: "sans-serif" }, [
                  _vm._v(_vm._s(info)),
                ])
              }),
              0
            ),
          ]
        )
      }),
      _vm._v(" "),
      _vm.currentPrice
        ? _c("div", { staticClass: "booking-summary__price sans-serif" }, [
            _c("b", [_vm._v(_vm._s(_vm.currentPrice) + " EUR")]),
            _vm._v(" "),
            _c("br"),
            _vm._v("\n    Gesamtpreis für alle Reiseteilnehmer\n  "),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "filter__toggle--slide" }, [
      _c("div", { staticClass: "arrow arrow--right" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "intro-label" }, [
      _c("b", { staticClass: "sans-serif" }, [_vm._v("Zusammenfassung")]),
      _c("br"),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Klicken Sie auf einen Bereich um eine Änderung Ihres Reisewunsches vorzunehmen:"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }